import { useTranslation } from '@flecto/translations'

import {
  type FilterField,
  filterTypeConfig,
  type FilterValue,
  type HandleFilterChange,
} from '../multi-select/filterTypeConfig'

export const getCheckboxGroupOptions = (
  field: FilterField,
  selectedFilters: FilterValue[],
  handleFilterChange: HandleFilterChange
) => {
  const { t } = useTranslation('shared', { keyPrefix: 'filters' })
  const { type, options, label } = field
  const config = filterTypeConfig[type] || { options, label }

  const translatedOptions =
    config.options?.map((option) => ({ ...option, label: t(option.label) })) ||
    []

  return {
    dataTestid: `checkbox-group-${field.key}`,
    options: translatedOptions,
    key: field.key,
    onChange: (value: string | string[]) =>
      handleFilterChange(field.key, value),
    value:
      (selectedFilters.find((f) => f.key === field.key)?.value as string[]) ||
      [],
  }
}
